import { memo, type JSX } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { ButtonSizes, Button, Icon, TextInput } from '@/shared/ui';

import './SearchServiceForm.scss';

interface Props {
  onSubmit: (query: string) => void;
  defaultValue?: string;
}

const MIN_LETTERS_TO_FILTER = 3;
const VALIDATION_INPUT_MESSAGE = `Введіть від ${MIN_LETTERS_TO_FILTER} літер`;

export const SearchServiceForm = memo<Props>(({ onSubmit, defaultValue = '' }) => {
  const { watch, control, handleSubmit } = useForm({
    defaultValues: {
      filter: defaultValue,
    },
  });

  const filter = watch('filter');

  const onReset = (): void => onSubmit('');

  return (
    <div className="internal-services-page__search-block__header-container">
      <form
        className="internal-services-page__search-block__input-container"
        onSubmit={handleSubmit((data) => onSubmit(data.filter))}
        onReset={onReset}
      >
        <Controller
          name="filter"
          control={control}
          render={({ field }): JSX.Element => (
            <TextInput
              {...field}
              label="Пошук"
              inputMode="search"
              maxLength={60}
              placeholder={VALIDATION_INPUT_MESSAGE}
              onClear={onReset}
            />
          )}
        />

        <Button
          className="internal-services-page__search-block__input-container__search-button"
          type={filter.length === 0 ? 'reset' : 'submit'}
          size={ButtonSizes.LG}
          disabled={(filter.length !== 0 && filter.length < MIN_LETTERS_TO_FILTER) || filter === defaultValue}
        >
          <Icon name="search" />
        </Button>
      </form>
    </div>
  );
});
